import React from "react";
import { Link } from 'react-scroll';

export default function About() {
  return (
    <div id="about" className="min-h-screen relative py-16 lg:py-0 lg:flex lg:items-center">
      <div className="w-11/12 sm:w-10/12 md:w-8/12 mx-auto flex flex-col lg:flex-row gap-8 lg:gap-0">
        {/* Text content */}
        <div className="w-full lg:w-7/12 text-primary flex flex-col justify-between">
          <div>
            <div className="mb-4">
              <span className="text-2xl">Hello!</span>
            </div>
            <div className="mb-4">
              <span className="text-xl">I am Susan, planner and designer based in Dallas, Texas</span>
            </div>
            <div className="mb-4">
              <span className="text-base lg:text-xl">In my free time, you can find me planning the next girl's trip, reading for the book club I started, browsing interior design inspo for my new home, or sipping on jasmine green milk tea - light ice and 50% sweet.</span>
            </div>
            <div className="mb-4">
              <span className="text-base lg:text-xl">I started this business because wedding planning has been my dream job since I was a kid. In my corporate job, I'm a planner for tech (and sometimes team events), but I'd much prefer using my creativity in planning something beautiful and help people build their special day.</span>
            </div>
            <div className="mb-6">
              <span className="text-base lg:text-xl">~ Susan</span>
            </div>
          </div>
          <div className="w-full flex justify-center">
            <Link to="services" smooth={true} offset={-75}>
              <button className="inline-flex bg-button py-4 px-8 rounded-full">
                <span className="uppercase text-primary text-xs">
                  Our Services
                </span>
              </button>
            </Link>
          </div>
        </div>

        {/* Image */}
        <div className="w-full lg:w-5/12 lg:pl-12 flex justify-center order-first lg:order-last">
          <img
            className="w-auto object-contain max-h-72 sm:max-h-96 lg:max-h-full"
            src={`${process.env.PUBLIC_URL}/images/susan.png`}
            alt="Susan"
          />
        </div>
      </div>
    </div>
  );
}